import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import { formatDate } from '../util';
import PointsCell from "./PointsCell";
import UserResult from "../common/UserResult";
import TagResult from "../common/TagResult";
import MessageProvider from "../classes/MessageProvider";
import MessageBox from "../comp/MessageBox";

type Props = { username: string }
type State = { data: UserResult | undefined }

export default class ProjectResultPage extends Component<ServiceCollectionParam & Props, {}> {

    messages = new MessageProvider(this.setState.bind(this));

    state : State = {
        data: undefined
    }

    async componentDidMount() {
        let currentUser = this.props.username;

        await this.props.services.dao.getProjectResultFor(currentUser)
            .then(userResult => {
                this.setState({ data: userResult });
            });

        const message = `Tester uusi töid vastu ei võta kuna esitatud kood on liialt sarnane teise tudengi tööle.
                  Seletus, miks see nii on, saatke aadressile mart.kalmo@taltech.ee.`;

        if (this.state.data?.codeMatchProblem) {
            this.messages.error(message);
        }
    }

    public isOnTime(row: TagResult): boolean {
        if (!row.dueDate || !row.passDate) {
            return false;
        }

        return new Date(row.passDate).getTime() < new Date(row.dueDate).getTime();
    }

    public getResultRows(userResult: UserResult): any {

        const minCompleted = userResult.isMinimumCompleted ? 'Jah' : 'Ei';

        let pointsInScale =
            userResult.mainPointsInScale
            + ' + '
            + userResult.bonusPointsInScale

        const calc = userResult.getExamResultCalculator();

        if (calc.examResultsExist()) {
            pointsInScale += ' + ' + calc.getTotalPoints();
        }

        const rows = [
            { label: 'Nõutud ülesanded esitatud', points: minCompleted },
            { label: 'Ülesannete punktid (ei ole lõpparvestuse punktid)', points: userResult.mainScore },
            { label: 'Lisaülesannete punktid (ei ole lõpparvestuse punktid)', points: userResult.bonusPoints },
            { label: 'Ülevaatuste punktid', points: userResult.reviewPoints },
            { label: 'Hilinemise punktid', points: userResult.latePenalties }
        ];

        if (calc.test1ResultsExist() && userResult.isTestResultConfirmed) {
            rows.push({ label: '1. kontrolltöö teooria punktid',
                        points: userResult.getTest1Results().theory.join(', ') });
            rows.push({ label: '1. kontrolltöö ülesannete punktid',
                        points: userResult.getTest1Results().exercises.join(', ') });
        }

        if (calc.test2ResultsExist() && userResult.isTestResultConfirmed) {
            rows.push({ label: '2. kontrolltöö teooria punktid',
                        points: userResult.getTest2Results().theory.join(', ') });
            rows.push({ label: '2. kontrolltöö ülesannete punktid',
                        points: userResult.getTest2Results().exercises.join(', ') });
        }

        if (calc.finalExamResultsExist() && userResult.isTestResultConfirmed) {
            rows.push({ label: 'Eksami teooria punktid',
                        points: userResult.getFinalExamResults().theory.join(', ') });
            rows.push({ label: 'Eksami ülesannete punktid',
                        points: userResult.getFinalExamResults().exercises.join(', ') });
        }

        if (userResult.isTestResultConfirmed) {
            rows.push({ label: 'Punktid Kokku (100st punktist, põhi + boonus + eksam)',
                points: pointsInScale });
        }

        const finalGrade = userResult.getFinalResults().gradeFinalGrade();

        if (finalGrade !== undefined) {
            rows.push({ label: 'Hinne senise tulemuse põhjal',
                        points: finalGrade });
        }

        return rows;
    }

    isCodeMatchProblem(tag: string) {
        return this.state.data?.codeMatchProblem == tag;
    }

    render() {
        if (this.state.data === undefined) {
            return '';
        }

        const username = this.state.data.username;

        return (
            <>
                <MessageBox messages={ this.messages.getMessages() } />

                <table className="table table-sm caption-top user-dashboard">
                <caption>Projekti tulemused</caption>
                <thead>
                <tr>
                    <th scope="col">Tag</th>
                    <th scope="col">Tähtaeg</th>
                    <th scope="col">Punktid (max)</th>
                    <th scope="col">Räsi</th>
                    <th scope="col">Punktid</th>
                    <th scope="col">Läbitud</th>
                    <th scope="col">Viimati käivitatud</th>
                </tr>
                </thead>
                <tbody>
                { this.state.data.results.map(tagResult =>
                    <tr key={ tagResult.tag }
                        className={ this.isCodeMatchProblem(tagResult.tag) ? 'table-danger' : '' } >
                        <td>{ tagResult.tag }{ this.exTypeMarker(tagResult) }</td>
                        <td>{ formatDate(tagResult.dueDate) }</td>
                        <td>{ tagResult.maxPoints }</td>
                        <td>{ tagResult.hash }</td>
                        <PointsCell userName={ username } tagResult={tagResult} />
                        <td className={
                            this.isOnTime(tagResult) ? 'text-success' : 'text-warning'
                        }>{ formatDate(tagResult.passDate) }</td>
                        <td>{ formatDate(tagResult.lastDate) }</td>
                    </tr>
                ) }
                </tbody>
            </table>

            * Pole kohustuslik, ** lisaülesanne.<br /><br />

            <table className="table table-sm caption-top user-dashboard">
                <caption>Koondtulemused</caption>
                <tbody>
                { this.getResultRows(this.state.data).map(row =>
                    <tr key={ Math.random() }>
                        <td>{ row.label }</td>
                        <td>{ row.points }</td>
                    </tr>
                ) }

                </tbody>
            </table>

            </>);
    }

    exTypeMarker(tagResult: TagResult) {
        if (tagResult.isBonus) {
            return '**';
        } else if (!tagResult.required) {
            return '*';
        } else {
            return '';
        }
    }

}
